import React, { useMemo } from 'react';
import {
    getPortfolioStatus,
    IN_EXECUTION, NOT_IMPLEMENTED,
} from 'constants/portfolioStatuses';
import { usePortfolio } from 'domain/Portfolio';
import Preloader from 'components/Preloader';
import PageNotFoundContent from 'components/PageNotFound/PageNotFoundContent';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const withPortfolioAccess = (Component: React.ComponentType<any>) => {
    const Portfolio = (props: any) => {
        const navigate = useNavigate();
        const { state } = useLocation();
        const { dfsClientId } = useParams();
        const { portfolio: { data, isLoading, error } } = usePortfolio() as any;

        const status = getPortfolioStatus({
            portfolioStatusId: data?.portfolioStatusId,
        });

        const pageNotFound = useMemo(() => [].includes(status as never), [status]);

        if (status === NOT_IMPLEMENTED) {
            navigate(`/client/${dfsClientId}/portfolios/${data.id}/funding-information`, { state });
        }

        if (status === IN_EXECUTION) {
            navigate(`/client/${dfsClientId}/portfolios/${data.id}/pending-orders`, { state });
        }

        if (data?.portfolioStatusId && pageNotFound) {
            return (
                <Preloader isLoading={isLoading} error={error}>
                    <PageNotFoundContent />
                </Preloader>
            );
        }

        return <Component status={status} {...props} />;
    };

    return Portfolio;
};

export default withPortfolioAccess;
